(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name airports.controller:AirportsCtrl
   *
   * @description
   *
   */
  angular
    .module('airport')
    .directive('focusOn',function($timeout) {
		return {
			restrict : 'A',
			link : function(vm,$element,$attr) {
				vm.$watch($attr.focusOn,function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	})
    .controller('AirportCtrl', AirportsCtrl);

  function AirportsCtrl(EventManagerService,AirportService,MessageService,PopupManager,applicationConstants,CommonMasterData) {
    var vm = this;
    vm.ctrlName = 'AirportCtrl';

    vm.model = {
        	searchOnGoing : false,
        	searchPanelToggle:true,
        	initialSearchDone: false,
        	editorMode:applicationConstants.EDITOR_STATUS.ADD,
        	searchCriteria:{
        		airportCode:null,
        		airportName : null,
            countryCode : null,
        		fuelSupplier : null,
        		layover : null,
        		base : null
             },
             masterList:{
            	 airportList : [],
            	 fuelSupplierList : [],
            	 airportsCategories : [],
            	 languages : [],
            	 countries : [],
            	 offsetTypes : [],
               airportCodeDisable:false,
               rotationEmailRequired:false
             },
             airportsList:[],
        	 defaultMinGroundTime : null,
             selectedAirport:null,
             selectedAirportLangRequerment:null,
             isElasticLoadingVisible:false
     };

      EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);

        vm.clickOnSearch = function () {
            vm.model.searchPanelToggle = ! vm.model.searchPanelToggle;
            vm.model.initialSearchDone = false;
        };

        vm.searchByOptions = function(searchParams){
        	setDefault();
        	vm.searchAirports();
        }

        vm.searchAirports = function() {
    		vm.model.airportsList = [];
    		vm.model.searchCriteria.startPosition = 1;
    		vm.model.initialSearchDone = true;
    		searchAirports();
    	};

        vm.selectAirport = function (selectedRowData) {
            vm.model.editorMode =  applicationConstants.EDITOR_STATUS.EDIT;
            vm.model.selectedAirport = AirportService.formatGridSelectedRow(selectedRowData);
            if(vm.model.selectedAirport.rotEmailRequired && (vm.model.selectedAirport.airportRotationEmail === null || vm.model.selectedAirport.airportRotationEmail === '')) {
              vm.model.masterList.rotationEmailRequired = true;
            }else{
              vm.model.masterList.rotationEmailRequired = false;
            }
            vm.model.selectedAirportLangRequerment = selectedRowData.airportLangReqList;
            vm.model.masterList.airportCodeDisable=true;
        };

        vm.addNewAirport = function () {
            vm.model.editorMode =  applicationConstants.EDITOR_STATUS.ADD;
            vm.model.selectedAirport = AirportService.getNewAirport();
            //set default min ground time initially
            vm.model.selectedAirport.minGroundTimeInMin = angular.copy(vm.model.defaultMinGroundTime);
            vm.model.selectedAirportLangRequerment = null;
            vm.model.masterList.airportCodeDisable=false;
        };

        vm.submitAirport = function(action, selectedItem) {
        	 vm.model.selectedAirport = selectedItem;
             if (action === applicationConstants.EDITOR_STATUS.DELETE){
            	 deleteAirportInfo(selectedItem);
             }else{
               if(!vm.model.masterList.rotationEmailRequired) {
                 saveAirportInfo();
               }
             }
        }

    vm.change = function ($event,flag, selectedItems, value) {
      if(flag ==='enableRotationEmail' || flag==='rotationEmail'){
        if(vm.model.selectedAirport.rotEmailRequired && (vm.model.selectedAirport.airportRotationEmail === null || vm.model.selectedAirport.airportRotationEmail === '')){
          vm.model.masterList.rotationEmailRequired = true;
        }else {
          vm.model.masterList.rotationEmailRequired = false;
        }

      }
      if(flag ==='matchingIndex'){
        setMatchingIndexForAirports(value);
      }
    }

    function setMatchingIndexForAirports(viewValue){
      if(viewValue !== " " && viewValue!== null) {
        angular.forEach(vm.model.masterList.airportList, function(apt) {
          apt.matchingIndex = apt.airPortCode.toLowerCase().indexOf(viewValue.toLowerCase());
        })
      }
    }

        function searchAirports() {
            showLoader(true);
            var searchParams = vm.model.searchCriteria;
            AirportService.searchAirportGridData(
            	searchParams,
                function (airports,startPosition) {
                    updateAirportsList(airports);
                    updateGridSearchStartPosition(startPosition);
                    vm.model.searchPanelToggle = false;
                    showLoader(false);
                    vm.model.searchOnGoing = false;
                },
                function (error) {
                    MessageService.error(error);
                    showLoader(false);
                }
            );
        }

        function getNextSetOfRecords() {
            vm.model.isElasticLoadingVisible = true;
            if(!vm.model.searchOnGoing){
            	vm.model.searchOnGoing = true;
            	searchAirports();
            }
        }

        function setDefault() {
        	vm.model.searchCriteria.pageSize = 100;
            vm.model.searchCriteria.startPosition = 1;
            vm.addNewAirport();
        }

        function updateAirportsList(airports) {
            angular.forEach(airports, function (airport) {
                vm.model.airportsList.push(airport);
            });
            vm.model.isElasticLoadingVisible = false;
        }

        function showLoader(flag) {
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
                flag: flag,
                target: 'airport',
                animationName: 'crewing-loader'
            });
        }

        function updateGridSearchStartPosition(startPosition) {
        	 vm.model.searchCriteria.startPosition = startPosition;
        }


        function saveAirportInfo() {
        	AirportService.saveAirport(vm.model.selectedAirportLangRequerment,
        		vm.model.selectedAirport,
                function (response) {
                    if(response.success){
                        MessageService.success('Successfully saved the record!');
                        vm.searchAirports();
                        vm.addNewAirport();
                        searchAirportCodes();
                    }else{
                        MessageService.error(response.errors[0]);
                    }
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }

        function deleteAirportInfo(selectedItem){
          var param = {
              title: 'Confirmation',
              messages: ["Do you want to delete this record"],
              flags: selectedItem
          };
          PopupManager.openModal('CONFIRM_DIALOG', param, confirmDeleteDialog);
        }


        function confirmDeleteDialog(pass) {
            if(pass==='YES'){
            	AirportService.deleteAirportInfo(vm.model.selectedAirport,
                    function (response) {
                        MessageService.success('Successfully deleted the record!');
                        vm.searchAirports();
                        vm.addNewAirport();
                        searchAirportCodes();
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                );
            }
        }

        function searchAirportCodes(){
        	AirportService.searchAirportMasterData(
              		 function(airports){
              			 vm.model.masterList.airportList = airports;
              		 },
              		 function(error){
              			 MessageService.error(error);
              		 }
               );
        }

        function searchOffSetTypes(){
        	vm.model.masterList.offsetTypes = AirportService.searchoffsetTypes();
        }


        AirportService.searchFuelSuppliersMasterData(
       		 function(fuelSuppliers){
       			 vm.model.masterList.fuelSupplierList= fuelSuppliers;
       		 },
       		 function(error){
       			 MessageService.error(error);
       		 }
       );

        AirportService.searchAirportCategories(
          		 function(airportCatList){
          			 vm.model.masterList.airportsCategories= airportCatList;
          		 },
          		 function(error){
          			 MessageService.error(error);
          		 }
        );

       AirportService.searchLanugages(
       		 function(langCatList){
       			 vm.model.masterList.languages= langCatList;
       		 },
       		 function(error){
       			 MessageService.error(error);
       		 }
       );

       AirportService.searchCountries(
    		 function(countries){
           dataProcess(countries);
       			 vm.model.masterList.countries = countries;
       		 },
       		 function(error){
       			 MessageService.error(error);
       		 }
       );

      function dataProcess(countries) {
         for (var i in countries){
           countries[i].description = countries[i].description + " ";
         }
         return countries;
       };

      searchAirportCodes();
      searchOffSetTypes();
      setDefault();

		//get default min ground infor
		(function() {
			CommonMasterData.getDefaultMinGroundTime(function(defaultMinGroundTime) {
				vm.model.defaultMinGroundTime = defaultMinGroundTime;
			}, function() {
				console.log('Default Min Ground Time retrieval error');
			});
		})();

  }
}());
